<template>
  <div class="integralUser seller-style">
    <h2 class="f18 fb normal gray_2">常用车辆（{{ identityType === 1 ? "企业" : "个人" }}）</h2>
    <div class="box30"></div>
    <div>
      <div class="flex items-center justify-between">
        <div class="flex flex1 items-center">
          <!-- <div class="lable">客户：</div>
          <el-input class="w240 mar20_r" placeholder="请输入姓名或手机号" v-model.trim="selVal"></el-input>
          <div class="lable">车牌号：</div>
          <el-input class="w240 mar20_r" placeholder="请输入车牌号" v-model.trim="selVal"></el-input>
          <el-button type="primary">查询</el-button> -->
        </div>
        <div>
          <el-button type="primary" @click="addVisible = true">添加车辆</el-button>
        </div>
      </div>
      <div class="box30"></div>
      <el-table border :data="list" row-class-name="pointer">
        <el-table-column show-overflow-tooltip prop="name" label="姓名" min-width="15%" />
        <el-table-column show-overflow-tooltip prop="tel" label="手机号" min-width="15%" />
        <el-table-column prop="licensePlateNum" label="车牌号" min-width="15%" />
        <el-table-column prop="isAbnormal" label="状态" width="180">
          <template slot-scope="scope">
            <span class="blue" v-if="scope.row.isAbnormal === 1">正常</span>
            <span class="red" v-else-if="scope.row.isAbnormal === 2">异常</span>
            <span v-else>审核中</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <div class="c_nx_blue" @click="delCart(scope.row.id)">删除</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex items-center mar40-t">
        <div class="gray9 flex-auto">共 {{ pageTotal }} 条记录 第 {{ pageNum }} / {{ totalPage }} 页</div>
        <el-pagination
          layout="prev, pager, next, sizes, jumper"
          background
          hide-on-single-page
          :page-size.sync="pageSize"
          :page-count="totalPage"
          :current-page.sync="pageNum"
          :page-sizes="[30, 50, 100]"
          @size-change="sizeChange"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog title="添加车辆" :visible.sync="addVisible" width="650px" center>
      <div class="flex justify-center">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="车主姓名" prop="name">
            <el-input class="w240" v-model.trim="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="tel">
            <el-input class="w240" v-model.trim="ruleForm.tel"></el-input>
          </el-form-item>
          <el-form-item label="车牌号" prop="licensePlateNum">
            <el-input class="w240" maxlength="8" minlength="7" v-model.trim="ruleForm.licensePlateNum"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="idCard">
            <el-input class="w240" placeholder="非必填项" maxlength="18" minlength="0" v-model.trim="ruleForm.idCard"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('ruleForm')">取 消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    const checkLicensePlate = (rule, value, callback) => {
      if (value) {
        // eslint-disable-next-line
        const reg =
          /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([A-Z0-9]{4,5}[A-Z0-9挂学警港澳]{1}$)|([0-9]{4,5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4,5}$))/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的车牌号"));
        }
      }
    };

    const checkIdCard = (rule, value, callback) => {
      if (!value) {
        callback();
      }
      // eslint-disable-next-line
      const reg18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      const reg15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
      if (reg18.test(value) || reg15.test(value)) {
        callback();
      } else {
        return callback(new Error("请输入正确的身份证号"));
      }
    };

    return {
      identityType: "",

      list: [],

      pageSize: 10,
      pageNum: 1,
      totalPage: 1,
      pageTotal: 1,

      addVisible: false,
      ruleForm: {
        name: "",
        tel: "",
        licensePlateNum: "",
        idCard: "",
      },
      rules: {
        name: [{ required: true, message: "请输入车主姓名", trigger: "blur" }],
        tel: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        licensePlateNum: [
          { required: true, message: "请输入车牌号", trigger: "blur" },
          { validator: checkLicensePlate, trigger: "blur" },
        ],
        idCard: [{ validator: checkIdCard, trigger: "blur" }],
      },
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    this.getList();
  },
  methods: {
    getList() {
      const { pageSize, pageNum } = this;
      this.$store
        .dispatch("comCart/getVehicleList", {
          pageSize,
          pageNum,
        })
        .then((data) => {
          const { list, totalPage, totalCount, identityType } = data;
          console.log(data);
          this.list = list;
          this.totalPage = totalPage;
          this.pageTotal = totalCount;
          this.identityType = identityType;
        });
    },
    // 修改每页显示个数
    sizeChange(pageSize) {
      this.pageSize = pageSize;
      this.pageNum = 1;
      this.getList();
    },

    // 修改页码
    currentChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },

    delCart(id) {
      this.$confirm("你确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store
          .dispatch("comCart/delVehicle", {
            id,
          })
          .then((res) => {
            console.log(res);
            if (res.code === "0") {
              this.$message.success("删除成功！");
              this.getList();
            } else {
              this.$message.warning(res.msg);
            }
          });
      });
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store.dispatch("comCart/addVehicle", this.ruleForm).then((res) => {
            console.log(res);
            if (res.code === "0") {
              this.$message.success("添加成功！");
              this.$refs[formName].resetFields();
              this.addVisible = false;
              this.getList();
            } else {
              this.$message.warning(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.ruleForm.name = "";
      this.ruleForm.licensePlateNum = "";
      this.ruleForm.tel = "";
      this.ruleForm.idCard = "";
      this.addVisible = false;
      this.$refs[formName].resetFields();
    },
  },
  // 监听器
  filters: {},
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
